import styled from 'styled-components';

export const Content = styled.section`
  margin-top: 80px;
`;

export const Title = styled.h1`
`;
